module.exports = __webpack_public_path__ + "static/media/active-link.068074f4.svg";